<template>
  <div
    v-if="userLoggedIn"
    class="
      background
      relative
      border border-gray-150
      shadow-md
      flex
      w-full
      items-center
      p-2
      rounded-xl
    "
  >
    <div class="relative h-28 w-28 bg-gray-200 rounded-full">
      <img
        v-if="profilePicture"
        alt="image"
        class="h-28 w-28 object-cover rounded-full overflow-hidden"
        :src="profilePicture"
      />
      <img
        v-else
        alt="image"
        class="h-28 w-28 object-cover rounded-full overflow-hidden"
        src="@/assets/icons/user.svg"
      />
      <img
        alt="image"
        class="absolute h-8 bottom-0 right-0"
        src="@/assets/icons/camera.svg"
      />
      <img
        alt="image"
        v-if="loadingPhoto"
        class="absolute animate-spin h-8 inset-0 mx-auto my-auto"
        src="@/assets/icons/spinner.svg"
      />
      <input
        id="profilePictureInput"
        type="file"
        accept="image/*"
        class="absolute w-8 h-8 opacity-0 bottom-0 right-0"
        :onchange="validateProfilePicture"
      />
    </div>
    <div class="text-left break-all flex-1 mx-4 pt-6 space-y-2">
      <p
        @click="confirmLogout"
        class="
          absolute
          bg-white
          text-red-600
          font-bold
          px-2
          shadow-md
          rounded-md
          border
          h-6
          right-2
          top-2
        "
      >
        Logout
      </p>
      <p class="text-xl mt-8 font-semibold">
        {{ displayName }}
      </p>
      <p class="">{{ authEmailOrPhone }}</p>
      <p
        @click="editProfile"
        class="text-bnb-mustard font-bold bg-white border px-2 rounded-md"
      >
        Edit Profile
      </p>
    </div>
  </div>
  <div v-else class="flex justify-between bg-bnb-mustard bg-opacity-25 p-4">
    <p>You are not logged in!</p>
    <button @click="login" class="bg-white px-2 font-bold text-bnb-mustard">
      Log in
    </button>
  </div>
</template>
<script>
import { Dialog } from "@capacitor/dialog";
import { Storage } from "@capacitor/storage";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import firebase from "firebase/app";
import "firebase/storage";
export default {
  data() {
    return {
      loadingPhoto: false,
      displayName: this.$store.state.user?.displayName || "No Name",

      authEmailOrPhone:
        this.$store.state.user?.email || this.$store.state.user?.phoneNumber,
    };
  },
  computed: {
    userLoggedIn() {
      return firebase.auth().currentUser;
    },
    profilePicture() {
      return this.$store.state.user?.photoURL;
    },
  },
  methods: {
    login() {
      this.$router.replace({ name: "Authenticate" });
    },
    confirmLogout() {
      Dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to log out?",
        okButtonTitle: "Yes",
      }).then((result) => {
        if (result.value) {
          Haptics.impact({ style: ImpactStyle.Medium });
          this.updateFCMToken();
        }
      });
    },
    updateFCMToken() {
      Storage.get({ key: "fcmToken" }).then((oldTokenObject) => {
        var oldToken = oldTokenObject.value;
        var uid = firebase.auth().currentUser?.uid;
        firebase
          .firestore()
          .collection("Users")
          .doc(uid)
          .get()
          .then((doc) => {
            var fcmTokens = doc.data().fcmTokens || [];
            var filteredTokens = [];
            filteredTokens = fcmTokens.filter((token) => token != oldToken);
            doc.ref.update({ fcmTokens: filteredTokens }).then(() => {
              this.logout();
            });
          });
      });
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.wipeUserData();
        })
        .catch((error) => {
          console.error("logout error: ", error);
        });
    },
    editProfile() {
      this.$router.push({ name: "EditProfile" });
    },
    validateProfilePicture() {
      if (!this.loadingPhoto) {
        this.loadingPhoto = true;
        var file = document.getElementById("profilePictureInput").files[0];
        var size = file.size;
        // process
        if (size <= 1500000) {
          this.$toast.info("Uploading...", {
            position: "bottom",
            duration: 1000,
          });
          this.uploadProfilePicture(file);
        } else {
          this.loadingPhoto = false;
          this.$toast.error("Too large. Max: 1.5 MB", {
            position: "bottom",
            duration: 4000,
          });
        }
      } else {
        this.$toast.error("Already Loading Photo", {
          position: "bottom",
          duration: 2000,
        });
      }
    },
    uploadProfilePicture(file) {
      firebase
        .storage()
        .ref()
        .child("ProfilePictures/" + firebase.auth().currentUser?.uid)
        .put(file)
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((url) => {
            firebase
              .auth()
              .currentUser?.updateProfile({ photoURL: url })
              .then(() => {
                firebase
                  .firestore()
                  .collection("Users")
                  .doc(firebase.auth().currentUser?.uid)
                  .update({ photoURL: url })
                  .then(() => {
                    this.loadingPhoto = false;
                  })
                  .catch((error) => {
                    this.loadingPhoto = false;
                    this.$toast.error(error.message, {
                      position: "bottom",
                      duration: 4000,
                    });
                  });
              })
              .catch((error) => {
                this.loadingPhoto = false;
                this.$toast.error(error.message, {
                  position: "bottom",
                  duration: 4000,
                });
              });
          });
        })
        .catch((error) => {
          this.loadingPhoto = false;
          this.$toast.error(error.message, {
            position: "bottom",
            duration: 4000,
          });
        });
    },
    wipeUserData() {
      localStorage.clear();
      localStorage.appLaunched = true;
      this.$toast.info("Logged Out!", {
        position: "bottom",
        duration: 2000,
      });
      window.history.go(-1);
    },
  },
};
</script>
